// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".body[data-v-af701b52]{color:#5c5c5c;background-image:linear-gradient(#ccf7fc,#fff);font-family:微软雅黑;font-size:14px}", ""]);
// Exports
module.exports = exports;
